var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3432 2.15364C16.1682 0.0839551 12.6281 0.0839551 10.4524 2.15317L10 2.58286L9.54813 2.15337C7.37223 0.0838768 3.83258 0.0841113 1.65668 2.15337C0.58832 3.16954 0 4.51739 0 5.94825C0 7.37958 0.58832 8.7272 1.65684 9.7438L9.51695 17.206C9.65215 17.3347 9.82621 17.3988 10 17.3988C10.1738 17.3988 10.3476 17.3344 10.483 17.2058L18.3432 9.7438C19.4114 8.72743 20 7.37962 20 5.94849C20 4.51739 19.4114 3.16978 18.3432 2.15364ZM17.3761 8.72626L10 15.7293L2.6241 8.72649C1.83695 7.97798 1.40352 6.9913 1.40352 5.94849C1.40352 4.90567 1.83695 3.91899 2.6241 3.17048C3.44516 2.38919 4.52352 1.9988 5.60211 1.9988C6.68094 1.9988 7.75977 2.38966 8.58082 3.17095L9.51648 4.05962C9.78734 4.31716 10.2124 4.31716 10.4833 4.05962L11.4192 3.17048C13.0615 1.60813 15.7336 1.60813 17.3759 3.17048C18.1628 3.91903 18.5965 4.90567 18.5965 5.94849C18.5965 6.9913 18.1628 7.97774 17.3761 8.72626Z",
    fill: "#0061DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.5b65f2e375547ad9240931fd70f3ba79.svg";
export { ForwardRef as ReactComponent };